import baseApi from "./baseApi";
import apiPaths from "./apiPaths";

export class matchesApi extends baseApi {
    constructor(baseUrl: string, userId: string) {
        super(baseUrl, userId);
    }

    public async GetScoreSummaryForMatch(matchId: string) {
        return await this.Get(apiPaths.GetScoreSummaryForMatch(matchId));
    }

    public async searchPreviousMatches(searchTeamOneId: string, searchTeamTwoId: string, seasonId: string, seriesId: string, pageSize: number, pageNumber: number, excludePlayers: boolean) {
        return await this.Get(apiPaths.searchPreviousMatches(searchTeamOneId, searchTeamTwoId, seriesId, seasonId, pageSize, pageNumber, excludePlayers));
    }
}